import { useEffect, useState,forwardRef,useImperativeHandle } from 'react'
import { Modal,message,Input,Typography, InputNumber, Space  } from 'antd';
import usePagAndCommon from '@/hooks/usePagAndCommon';
import { ResDataType } from "@/services/ajax";
import { cancelPriv,privListType } from '@/services/afterSales';
import styles from './index.module.scss';
import { produce } from 'immer'
const { Text } = Typography;

const BatchModal = (props:{ save: () => void },ref:any)=> {
    const { save } = props;
    const { isModalOpen, setIsModalOpen } = usePagAndCommon();
    const [selected,setSelected] = useState<privListType[]>([]);
    const showModal = (selectedList:privListType[]) => {
        setSelected(selectedList);
        setIsModalOpen(true);
    };
    const Batch = () => {
        return (
            <div style={{ width:'100%' }}>
                {selected.map((item,index)=>{
                    return <div className={styles.batchItem} key={item.userActivityId}>
                        <div className={styles.priId}>权益包：{item.name}</div>
                        <span>
                        退款金额：
                        </span>
                        <InputNumber style={{ width:'15%' }} placeholder='退款金额' value={item.refundAmount} onChange={(e)=>{
                            setSelected(produce((draft) => {
                                draft[index].refundAmount = e || 0
                            }))
                        }} className={styles.input} min={0} />
                         <span>
                        备注：
                        </span>
                        <Input placeholder='备注' style={{ width:'40%' }} value={item.remark} onChange={(e)=>{
                            setSelected(produce((draft) => {
                                draft[index].remark = e.target.value || ''
                            }))
                        }} className={styles.input}  />
                    </div>
                })}
            </div>
        )
    }

    const handleOk = async () => {
        const data = selected.map(item=> {
            return {userActivityId:item.userActivityId,refundAmount:item.refundAmount,remark:item.remark}
        })
        const res = await cancelPriv({datas:data}) as ResDataType;
        if (res.code == 0) {
            message.success('作废成功');
            save();
        } else {
            message.error(res.message);
        }
        setIsModalOpen(false);
    };

    useImperativeHandle(ref, () => ({
        open: (selectedList: privListType[]) => showModal(selectedList),
    }))
  return (
    <div>
        <Modal
            maskClosable={false}
            width={800}
            title="批量作废"
            cancelText="取消" 
            okText="确定"
            open={isModalOpen}
            onOk={()=>{handleOk()}}
            onCancel={()=>{setIsModalOpen(false)}}
        >
            { Batch() }
        </Modal> 
    </div>
    
  )
}

export default forwardRef(BatchModal)